module.exports = "/_next/static/media/a0e80f23f871b4419bf10edeb8770065.svg";